import type { FeedbackEntry } from '@/bindings/FeedbackEntry'
import { Badge } from '@/components/badge'
import { Card } from '@/components/layout'
import { describeFeedback } from '@/features/feedback/describe'
import { useLanguage } from '@/lib/i18n/store'
import { useT } from '@/lib/i18n/translate'
import { formatDateTime } from '@/lib/time'

/** One feedback row: when, who, what it is about, and the message itself. */
export function FeedbackEntryRow({ entry }: { entry: FeedbackEntry }) {
  const t = useT()
  const language = useLanguage()
  const { author } = entry
  return (
    <Card className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <time dateTime={entry.created_at} className="text-muted">
          {formatDateTime(entry.created_at, language)}
        </time>
        {author === null ? (
          <Badge tone="muted">{t('feedback.author.anonymous')}</Badge>
        ) : author.deleted ? (
          <Badge tone="muted">{t('feedback.author.deleted')}</Badge>
        ) : (
          <span className="font-medium">{author.name ?? t('feedback.author.unnamed')}</span>
        )}
        <span className="text-muted">{describeFeedback(entry, t)}</span>
      </div>
      <p className="wrap-break-word whitespace-pre-line">{entry.message}</p>
    </Card>
  )
}
